/**
 * Lightweight HTML sanitizer (no external deps).
 * Strips scripts, event handlers, and dangerous URLs from CMS/user HTML.
 */
export function sanitizeHtml(dirty) {
  if (dirty == null || dirty === false) return "";
  let html = String(dirty);

  // Remove dangerous tags and their content
  html = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
  html = html.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "");
  html = html.replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, "");
  html = html.replace(/<object\b[^<]*(?:(?!<\/object>)<[^<]*)*<\/object>/gi, "");
  html = html.replace(/<embed\b[^>]*>/gi, "");
  html = html.replace(/<link\b[^>]*>/gi, "");
  html = html.replace(/<meta\b[^>]*>/gi, "");
  html = html.replace(/<base\b[^>]*>/gi, "");
  html = html.replace(/<form\b[^<]*(?:(?!<\/form>)<[^<]*)*<\/form>/gi, "");

  // Strip inline event handlers (onclick, onerror, ...)
  html = html.replace(/\s+on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");

  // Neutralize javascript: / vbscript: / data:text/html URLs
  html = html.replace(/(href|src|xlink:href)\s*=\s*(['"])\s*javascript:[\s\S]*?\2/gi, '$1="#"');
  html = html.replace(/(href|src)\s*=\s*(['"])\s*vbscript:[\s\S]*?\2/gi, '$1="#"');
  html = html.replace(/(href|src)\s*=\s*(['"])\s*data\s*:\s*text\/html[\s\S]*?\2/gi, '$1="#"');

  // Remove expression() CSS (legacy IE)
  html = html.replace(/expression\s*\(/gi, "invalid(");

  return html;
}

export default sanitizeHtml;
